module.exports = __webpack_public_path__ + "static/media/Checked.fb22fda1.svg";